import { signal, WritableSignal } from '@angular/core';
import { BondLookupUIControlStage } from './intake-form-bond-lookup.types';

export const bondLookupStageSignals: Record<BondLookupUIControlStage, WritableSignal<boolean>> = {
  [BondLookupUIControlStage.State]: signal(true),
  [BondLookupUIControlStage.BondFamily]: signal(false),
  [BondLookupUIControlStage.StateBond]: signal(false),
  [BondLookupUIControlStage.WriteIn]: signal(false),
  [BondLookupUIControlStage.Penalty]: signal(false),
  [BondLookupUIControlStage.PenaltyOptions]: signal(false),
  [BondLookupUIControlStage.PenaltyEntered]: signal(false),
  [BondLookupUIControlStage.StateBondOptions]: signal(false),
  [BondLookupUIControlStage.BondSelectionCompleted]: signal(false),
};

export function isStageActive(stage: BondLookupUIControlStage): boolean {
  // Guard for PenaltyOptions
  if (stage === BondLookupUIControlStage.PenaltyOptions) {
    return bondLookupStageSignals[BondLookupUIControlStage.Penalty]() &&
           bondLookupStageSignals[BondLookupUIControlStage.PenaltyOptions]();
  }
  return bondLookupStageSignals[stage]();
}

export function setStageActive(stage: BondLookupUIControlStage, active: boolean): void {
  bondLookupStageSignals[stage].set(active);
}
